// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ag-header-cell,.ag-header-group-cell{border-right:1px solid #e2e2e2!important}.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row){background:#eee;cursor:pointer!important}.ag-container{height:100%!important;display:flex;flex-direction:column}.ag-grid{height:1px;min-height:1px;flex-grow:1}.ag-cell{font-size:1.1em!important}.ag-header-cell-text{font-size:1.3em!important;font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
